import { first, last } from 'lodash';

// ***************************************************************************************
// onMoveSubtitle permet de bouger le sous-titre vers le haut, bas, droite, gauche ou au centre
// ***************************************************************************************
export function onMoveSubtitle(key) {
  this.addNewActionForUndo('onMoveSubtitle');

  switch (key) {
    case 'MOVEUP':
      this.onMoveSubtitleToUp(this.currentLine);
      break;
    case 'MOVEDOWN':
      this.onMoveSubtitleToDown(this.currentLine);
      break;
    case 'SETDIALOG':
      this.onSetDialog();
      return;
    case 'MOVELEFT':
      this.onMoveSubtitleToLeft();
      break;
    case 'MOVERIGHT':
      this.onMoveSubtitleToRight();
      break;
    case 'MOVESUBTITLETOLEFT':
    case 'MOVESUBTITLETORIGHT':
    case 'MOVESUBTITLETOCENTER':
      this.onMoveSubtitleTo(key);
      break;

    default:
      throw new Error('key not implemented');
  }
}

// ***************************************************************************************
// onMoveSubtitleToUp permet de bouger le sous-titre vers le haut
// ***************************************************************************************
export function onMoveSubtitleToUp(currentLine) 
{
  const teletext =  this.props.subtitleParameters.teletext;
  const doubleHeight = currentLine.doubleHeight ?? this.props.subtitleParameters.doubleHeight;

  //console.log ("subtitle", this.subtitle)
  //console.log ("current line", currentLine)
  //console.log ("index ", currentLine.index)
  if (currentLine.index >= this.subtitle.lines.length) currentLine.index= this.subtitle.lines.length -1;
  if (currentLine.index < 0) return;
  this.subtitle.lines[currentLine.index].verticalPos = this.subtitle.lines[currentLine.index].verticalPos - (teletext?1:2);

    // premier passage on remonte les lignes au dessus
  for (var l=currentLine.index-1; l>=0; l--)
  {
    const verticalPosS = this.subtitle.lines[l+1].verticalPos;
    const verticalPosP = this.subtitle.lines[l].verticalPos;

    var pmin = verticalPosS - (doubleHeight?2:1);
    if (verticalPosP>pmin) this.subtitle.lines[l].verticalPos = pmin;
  }

  // Test de cohérence
  for (var l=0; l <= currentLine.index; l++)
  {
      var posmin = 1;
      if (l !==0)
        posmin = this.subtitle.lines[l-1].verticalPos + (doubleHeight?2:1);
      if (this.subtitle.lines[l].verticalPos < posmin)
        this.subtitle.lines[l].verticalPos = posmin;
  }

  this.onChange();
  return;
}

export function onMoveLineToUp(currentLine) {
  let { verticalPos } = currentLine;
  if (!verticalPos) {
    throw new Error('verticalPos undefined');
  }

  const doubleHeight = currentLine.doubleHeight ?? this.props.subtitleParameters.doubleHeight;
  const diffVerticalPos = doubleHeight ? 2 : 1;
  const minVerticalPos = doubleHeight ? 2 : 1;


  if (
    verticalPos === minVerticalPos ||
    verticalPos - diffVerticalPos < minVerticalPos
  ) {
    return;
  }

  // Si ce n'est pas la première ligne
  if (currentLine.index !== 0) {
    let canUp = true;
    const originalPositions = new Map(); // Stocke les valeurs originales

    for (let i = currentLine.index - 1; i >= 0; i--) {
      const line = this.subtitle.lines[i];

      const diff = verticalPos - line.verticalPos;

      if (diff === diffVerticalPos) {
        const verticalPosOfLine = line.verticalPos - diffVerticalPos;
        if (verticalPosOfLine < minVerticalPos) {
          canUp = false;
          break;
        }

        // Sauvegarde la position originale avant de la modifier
        if (!originalPositions.has(line)) {
          originalPositions.set(line, line.verticalPos);
        }

        line.verticalPos = verticalPosOfLine;
      }

      verticalPos -= diffVerticalPos;
    }

    if (!canUp) {
      // Restauration des valeurs originales
      originalPositions.forEach((oldPos, line) => {
        line.verticalPos = oldPos;
      });
      return;
    }
  }

  currentLine.verticalPos -= diffVerticalPos;

  this.onChange();
}
// ***************************************************************************************
// onSetDialog 
// ***************************************************************************************
export function onSetDialog() 
{
  const teletext =  this.props.subtitleParameters.teletext;
  const { doubleHeight } = this.props.subtitleParameters;

  const baseline = this.props.subtitleParameters.verticalPos;
  

  // cas 1 une seule ligne
  if (this.subtitle.lines.length === 1)
  {
    if (this.subtitle.lines[0].verticalPos !== baseline)
      this.subtitle.lines[0].verticalPos = baseline;
  }
  else
  {
     if (this.subtitle.lines.length > 1)
     {
        const basenormale =  baseline -2 ;
        const basediag = teletext?(baseline-3):(baseline-4); // ligne dialog
   
        if (basediag < 1) return;

        // est-ce en normale
        if (
              (this.subtitle.lines[this.subtitle.lines.length-2].verticalPos === basenormale) &&
              (this.subtitle.lines[this.subtitle.lines.length-1].verticalPos === baseline)
          )

        {
          this.subtitle.lines[this.subtitle.lines.length-2].verticalPos = basediag;
          this.subtitle.lines[this.subtitle.lines.length-1].verticalPos = baseline;
        }
        else
        {


          this.subtitle.lines[this.subtitle.lines.length-2].verticalPos = basenormale;
          this.subtitle.lines[this.subtitle.lines.length-1].verticalPos = baseline;
        }


     }
  }

  
  this.onChange();
  return;
}
// ***************************************************************************************
// onMoveSubtitleToDown permet de bouger le sous-titre vers le bas
// ***************************************************************************************

export function onMoveSubtitleToDown(currentLine) 
{
  const teletext =  this.props.subtitleParameters.teletext;
  const doubleHeight = currentLine.doubleHeight ?? this.props.subtitleParameters.doubleHeight;

  if (currentLine.index >= this.subtitle.lines.length) currentLine.index= this.subtitle.lines.length -1;
  if (currentLine.index < 0) return;



  this.subtitle.lines[currentLine.index].verticalPos = this.subtitle.lines[currentLine.index].verticalPos + (teletext?1:2);

    // premier passage on descend les lignes au dessous
  for (var l=currentLine.index+1 ; l < this.subtitle.lines.length; l++)
  {
    const verticalPosLP = this.subtitle.lines[l-1].verticalPos;
    const verticalPosL = this.subtitle.lines[l].verticalPos;

    var pmin = verticalPosLP +  (doubleHeight?2:1);
    if (verticalPosL<pmin) this.subtitle.lines[l].verticalPos = pmin;
  }
  
  // Test de cohérence
  for (var l=(this.subtitle.lines.length-1); l >= currentLine.index; l--)
  {
      var posmin = doubleHeight?22:23;
      if (l !==(this.subtitle.lines.length-1))
        posmin = this.subtitle.lines[l+1].verticalPos - (doubleHeight?2:1);
      if (this.subtitle.lines[l].verticalPos > posmin)
        this.subtitle.lines[l].verticalPos = posmin;
  }
  
  this.onChange();
  return;
}

export function onMoveLineToDown(currentLine) {
  let { verticalPos } = currentLine;
  if (!verticalPos) {
    throw new Error('verticalPos undefined');
  }

  const { displayNumberOfLines } = this.props.subtitleParameters;
  const doubleHeight = currentLine.doubleHeight ?? this.props.subtitleParameters.doubleHeight;
  const diffVerticalPos = doubleHeight ? 2 : 1;

  if (
    verticalPos === displayNumberOfLines ||
    verticalPos + diffVerticalPos > displayNumberOfLines
  ) {
    return;
  }

  // si ce n'est pas la dernière ligne
  if (currentLine.index !== this.subtitle.lines.length - 1) {
    let canDown = true;
    const originalPositions = new Map(); // Stocke les valeurs originales

    for (let i = currentLine.index + 1; i < this.subtitle.lines.length; i++) {
      const line = this.subtitle.lines[i];

      const diff = line.verticalPos - verticalPos;

      if (diff === diffVerticalPos) {
        const verticalPosOfLine = line.verticalPos + diffVerticalPos;
        if (verticalPosOfLine > displayNumberOfLines) {
          canDown = false;
          break;
        }

        // Sauvegarde la position originale avant de la modifier
        if (!originalPositions.has(line)) {
          originalPositions.set(line, line.verticalPos);
        }

        line.verticalPos = verticalPosOfLine;
      }

      verticalPos += diffVerticalPos;
    }

    if (!canDown) {
      // Restauration des valeurs originales
      originalPositions.forEach((oldPos, line) => {
        line.verticalPos = oldPos;
      });

      return;
    }
  }

  currentLine.verticalPos += diffVerticalPos;

  this.onChange();
}

// ***************************************************************************************
// onMoveSubtitleTo permet de changer l'alignement du sous-titre vers la droite, gauche ou au centre
// ***************************************************************************************
export function onMoveSubtitleTo(key) {
  // 0 = left , 1 = right , 2 = center, 3 = manual

  /*const align =
    this.currentLine.align ?? this.props.subtitleParameters.defaultAlignment;

  if (align === 3) {
    this.currentLine.horizontalPos = 0;
  }*/

  switch (key) {
    case 'MOVESUBTITLETOLEFT':
      this.setAlignToLines(0);
      break;
    case 'MOVESUBTITLETORIGHT':
      this.setAlignToLines(1);
      break;
    case 'MOVESUBTITLETOCENTER':
      this.setAlignToLines(2);
      break;

    default:
      throw new Error('key not implemented');
  }

  this.onChange();
}

// ***************************************************************************************
// onMoveSubtitleToLeft permet de bouger le sous-titre vers la gauche
// ***************************************************************************************
export function onMoveSubtitleToLeft() {
  // 3 = position dans "horizontalPos" en %

  const align =
    this.currentLine.align ?? this.props.subtitleParameters.defaultAlignment;


  // Cas particulier du teletexte
  if (this.props.subtitleParameters.teletext)
  {
    if (!("horizontalPos" in this.currentLine)) this.currentLine.horizontalPos = 0; // au cas ou
    

    const minmax = this.getTeletextMinMax (this.currentLine);

    if (align === 0) // déja à gauche
    {
        this.currentLine.horizontalPos = minmax.min * 2.5;
        this.onChange();
        return;
    }



    if (align === 3)
    {
       var min = Math.floor(this.currentLine.horizontalPos * 40 / 100);
       min--;

       
       if (min > minmax.min)
       {
          this.currentLine.horizontalPos = min * 2.5;
          this.onChange();
          return;
       }
      this.currentLine.horizontalPos = minmax * 2.5;
      this.currentLine.align = 0; // on cale à gauche

      this.onChange();
      return;
    }

    if (align === 2) // cas du centrage vers libre
    {
      var min = 20 - (minmax.len/2) - 1;
      if (min < minmax.min)
      {
        this.currentLine.horizontalPos = minmax.min * 2.5;
        this.currentLine.align = 0; // on cale à gauche
        this.onChange();
        return;
      }
      this.currentLine.horizontalPos = min * 2.5;
      this.currentLine.align = 3; // en passe en libre
      this.onChange();
      return;
    }
  
    if (align === 1) // cas du centrage vers libre
    {
      var min = 39 - minmax.len - 1;
      if (min < minmax.min)
      {
        this.currentLine.horizontalPos = minmax.min * 2.5;
        this.currentLine.align = 0; // on cale à gauche
        this.onChange();
        return;
      }
      this.currentLine.horizontalPos = min * 2.5;
      this.currentLine.align = 3; // en passe en libre
      this.onChange();
      return;
    }
    
    this.onChange();
    return;
  }

  // left
  if (align === 0) {
    return;
  }



  if (align !== 3) {
    this.currentLine.align = 3;
  }

  const { startX } = this.currentLine;
  const { marginLeft } = this.props.displayParameters;
  const dMarginLeft = (parseFloat(marginLeft) / 100) * this.width;

  var x = startX;
  if (this.props.subtitleParameters.teletext)
    x = x - this.width/40;
  else
    x = x - dMarginLeft;

  if (x <= dMarginLeft) {
    this.currentLine.horizontalPos = undefined;
    this.currentLine.align = 0;
  } else {
    const horizontalPos = (x / this.width) * 100;
    this.currentLine.horizontalPos = horizontalPos;
  }

  this.onChange();
}

// ***************************************************************************************
// onMoveSubtitleToRight permet de bouger le sous-titre vers la droite
// ***************************************************************************************
export function onMoveSubtitleToRight() {
  const align =
    this.currentLine.align ?? this.props.subtitleParameters.defaultAlignment;


  // Cas particulier du teletexte
  if (this.props.subtitleParameters.teletext)
  {
    if (!("horizontalPos" in this.currentLine)) this.currentLine.horizontalPos = 0; // au cas ou
    

    const minmax = this.getTeletextMinMax (this.currentLine);
    

    if (align === 1) // déja à droite
    {
        this.currentLine.horizontalPos = minmax.max * 2.5;
        this.onChange();
        return;
    }



    if (align === 3)
    {
       var min = Math.floor(this.currentLine.horizontalPos * 40 / 100);
       min++;

       
       if (min < minmax.max)
       {
          this.currentLine.horizontalPos = min * 2.5;
          this.onChange();
          return;
       }
      this.currentLine.horizontalPos = minmax.max * 2.5;
      this.currentLine.align = 1; // on cale à droite

      this.onChange();
      return;
    }

    if (align === 2) // cas du centrage vers libre
    {
      var min = 20 - (minmax.len/2) + 1;
      if (min > minmax.max)
      {
        this.currentLine.horizontalPos = minmax.max * 2.5;
        this.currentLine.align = 1; // on cale à droite
        this.onChange();
        return;
      }
      this.currentLine.horizontalPos = min * 2.5;
      this.currentLine.align = 3; // en passe en libre
      this.onChange();
      return;
    }
  
    if (align === 0) // cas du gauche vers libre
    {
      var min = minmax.min + 1;
      if (min > minmax.max)
      {
        this.currentLine.horizontalPos = minmax.max * 2.5;
        this.currentLine.align = 1; // on cale à droite
        this.onChange();
        return;
      }
      this.currentLine.horizontalPos = min * 2.5;
      this.currentLine.align = 3; // en passe en libre
      this.onChange();
      return;
    }
    
    this.onChange();
    return;
  }


  // right
  if (align === 1) {
    return;
  }

  if (align !== 3) {
    this.currentLine.align = 3;
  }

  const { startX, width } = this.currentLine;
  const { marginRight, marginLeft } = this.props.displayParameters;

  const dMarginRight = (parseFloat(marginRight) / 100) * this.width;
  const dMarginLeft = (parseFloat(marginLeft) / 100) * this.width;

  var x = startX;
  if (this.props.subtitleParameters.teletext)
    x = x + this.width/40;
  else
    x = x + dMarginLeft;


  if (x + width >= this.width - dMarginRight - dMarginLeft) {
    this.currentLine.horizontalPos = undefined;
    this.currentLine.align = 1;
  } else {
    const horizontalPos = (x / this.width) * 100;
    this.currentLine.horizontalPos = horizontalPos;
  }

  this.onChange();
}

// ***************************************************************************************
// onRotateWord permet de monter ou descendre le mot à la première ou deuxième ligne
// ***************************************************************************************
export function onRotateWord(key) {
  if (key === 'ROTATEWORDTOUP') {
    this.onRotateWordToUp();
  } else {
    this.onRotateWordToDown();
  }
}

// ***************************************************************************************
// onRotateWordToUp permet de déplacer le premier mot de la deuxième ligne à la fin de la première ligne
// ***************************************************************************************
export function onRotateWordToUp() {
  // Faire l'historique
  this.addNewActionForUndo('onRotateWordToUp');

  if (this.subtitle.lines.length === 1) {
    const newLine = this.createNewLine(
      this.subtitle,
      this.subtitle.lines[0],
      false
    );

    if (!newLine) {
      this.cancelUndo();
      return;
    }

    this.subtitle.lines.unshift(newLine);
  }

  const firstLine = this.subtitle.lines[0];
  const secondLine = this.subtitle.lines[1];

  const firstWord = first(secondLine.words);
  if (!firstWord) {
    this.cancelUndo();
    return;
  }

  const nbChars = this.getSentence(firstLine).length + firstWord.letters.length;
  const maxLength = this.getMaxLength(firstLine);

  if (nbChars > maxLength) {
    this.cancelUndo();

    const onShowPopup = this.onShowPopup ?? this.props.onShowPopup;

    onShowPopup({
      title: '',
      text: {
        fr: 'Vous ne pouvez pas déplacer le premier mot de la deuxième ligne à la fin de la première ligne car vous dépassez la limite du nombre de caractères autorisé.',
        en: "You can't move the first word of the second line to the end of the first line, because you've exceeded the limit on the number of characters allowed.",
      },
      buttons: [],
      showIcon: true,
      icon: null,
    });

    return;
  }

  secondLine.words.shift();
  firstLine.words.push(firstWord);

  this.onChange();
}

// ***************************************************************************************
// onRotateWordToDown permet de déplacer le dernier mot de la première ligne au début de la deuxième ligne
// ***************************************************************************************
export function onRotateWordToDown() {
  // Faire l'historique
  this.addNewActionForUndo('onRotateWordToDown');

  if (this.subtitle.lines.length === 1) {
    const newLine = this.createNewLine(this.subtitle, this.subtitle.lines[0]);

    if (!newLine) {
      this.cancelUndo();
      return;
    }

    this.subtitle.lines.push(newLine);
  }

  const firstLine = this.subtitle.lines[0];
  const secondLine = this.subtitle.lines[1];

  const lastWord = last(firstLine.words);

  if (!lastWord) {
    this.cancelUndo();
    return;
  }

  const nbChars = this.getSentence(secondLine).length + lastWord.letters.length;
  const maxLength = this.getMaxLength(secondLine);

  if (nbChars > maxLength) {
    this.cancelUndo();

    const onShowPopup = this.onShowPopup ?? this.props.onShowPopup;

    onShowPopup({
      title: '',
      text: {
        fr: 'Vous ne pouvez pas déplacer le dernier mot de la première ligne au début de la deuxième ligne car vous dépassez la limite du nombre de caractères autorisé.',
        en: "You can't move the last word of the first line to the beginning of the second line, because you've exceeded the limit on the number of characters allowed.",
      },
      buttons: [],
      showIcon: true,
      icon: null,
    });

    return;
  }

  firstLine.words.pop();
  secondLine.words.unshift(lastWord);

  this.onChange();
}
